module.exports = __webpack_public_path__ + "img/lagerausbildung-4bohrungen-en.52f01f1f.png";